module.exports = __webpack_public_path__ + "img/2004.29b13be5.png";